import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  COLOUR_FACET_ID,
  COLOUR_ENRICHMENT_LANG,
  COLOUR_ENRICHMENT_CHANNEL,
} from "../constants";
import logger from "../../../../lib/logger";
import { getFacetData } from "../../../../lib/api/facet";

const getColourEnrichments = createAsyncThunk(
  "facet/getColourEnrichments",
  async (_, { rejectWithValue }) => {
    try {
      return await getFacetData({
        facetId: COLOUR_FACET_ID,
        lang: COLOUR_ENRICHMENT_LANG,
        channel: COLOUR_ENRICHMENT_CHANNEL,
      });
    } catch (error) {
      error.message = `getColourEnrichments failed, and caught error: ${error.message}`;
      logger.error(error);

      return rejectWithValue(error);
    }
  },
);

export default getColourEnrichments;
